import { useLingui } from '@lingui/react/macro';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { memo, useState } from 'react';

import { cn } from '../../lib/cn';
import { Markdown } from '../../ui';

export interface ReasoningBlockProps {
  reasoning: string;
}

export const ReasoningBlock = memo(({ reasoning }: ReasoningBlockProps) => {
  const { t } = useLingui();
  const [expanded, setExpanded] = useState(false);

  if (!reasoning.trim()) {
    return null;
  }

  return (
    <div className='mb-1 w-full max-w-full rounded-2xl border border-chat-border/40 bg-chat-surface/30'>
      <button
        type='button'
        aria-expanded={expanded}
        onClick={() => setExpanded(prev => !prev)}
        className={cn(
          'flex w-full items-center gap-2 rounded-2xl px-3 py-1.5 text-left',
          'text-xs text-chat-muted-foreground transition-colors hover:bg-chat-surface/60',
        )}
      >
        {expanded ? (
          <ChevronDown className='size-3.5 shrink-0 opacity-70' />
        ) : (
          <ChevronRight className='size-3.5 shrink-0 opacity-70' />
        )}
        <span className='min-w-0 flex-1 truncate'>{t`Thinking`}</span>
      </button>

      {expanded ? (
        <div className='px-3 pb-2 text-xs text-chat-muted-foreground [overflow-wrap:anywhere]'>
          <Markdown>{reasoning}</Markdown>
        </div>
      ) : null}
    </div>
  );
});
